export default __webpack_public_path__ + "static/media/wrong-audio.70fff5c7.wav";